import React from 'react'
import TypeFlash  from './type-flash'


export default (props => {
    return <TypeFlash {...props} isBlack />
})